import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import constants from '../../constants';
import {callAction, callTargetedAction} from '../../framework';
import TextInput from 'client/generic/Forms/TextInput/TextInput.react';
import AudioPlayer from 'generic/AudioPlayer/AudioPlayer.react';
import supplementEditorStore from 'client/Supplements/SupplementEditor/SupplementEditor.store';
import supplementEditorActions from 'client/Supplements/SupplementEditor/SupplementEditor.actions';
import WindowConfirm from 'generic/WindowConfirm/WindowConfirm.react';
import windowConfirmActions from 'generic/WindowConfirm/WindowConfirmActions';
import Button from 'sg/Button/Button.react';
import {AuthoringSupplement as AuthoringSupplementModelV1} from 'resources/GeneratedModels/AuthoringSupplement/AuthoringSupplementModel.v1';
import './audio-editor.scss';

export default class AudioEditor extends React.Component {
  static propTypes = {
    supplement: PropTypes.instanceOf(AuthoringSupplementModelV1),
    onChange: PropTypes.func,
    errors: ImmutablePropTypes.map
  };

  UNSAFE_componentWillMount() {
    const {supplement} = this.props;
    const caption = supplement.getContent().get('caption', '');
    callAction(supplementEditorActions.MODIFY_ACTIVE_SUPPLEMENT, {
      setter: 'setCaption',
      value: caption
    });
  }

  clearAudioModalStoreName = 'SupplementAudioEditor--ClearAudioModal';

  clearAudio() {
    callAction(supplementEditorActions.MODIFY_ACTIVE_SUPPLEMENT, {
      setter: 'setAudio',
      value: ''
    });
    callAction(supplementEditorActions.VALIDATE_SUPPLEMENT, 'audio');
  }

  uploadAudio(e) {
    const element = e.target;
    callAction(supplementEditorActions.UPLOAD_FILE, {
      name: element.name,
      setter: element.dataset.setterMethod,
      file: element.files[0]
    });
  }

  showModal = () => {
    callTargetedAction({
      name: windowConfirmActions.SHOW_MODAL,
      targetStore: this.clearAudioModalStoreName
    });
  };

  render() {
    const {supplement} = this.props;
    const {errors} = this.props;
    const isUploadPending = supplementEditorStore.isUploadPending();
    const uploadButtonClasses = classnames('audio-editor__button', {
      'audio-editor__button--disabled': isUploadPending
    });
    const uploadError = errors.get('audio');

    // @todo: Replace the following with a generic uploader component
    const uploadManager = this.props.supplement.getAudio() ? (
      <div className='audio-editor__input audio-editor__input--upload-manager'>
        <AudioPlayer
          caption={supplement.getCaption()}
          inline={supplement.getContent().get('inline')}
          src={`${constants.CDN_ASSETS_HOST  }/${  supplement.getAudio()}`}
        />
        <Button color='red' onClick={this.showModal} text='Clear audio' />
      </div>
    ) : (
      <div className='audio-editor__input audio-editor__input--upload-manager'>
        <label className={uploadButtonClasses} htmlFor='audio'>
          Choose File
        </label>
        <input
          className='audio-editor__button'
          data-setter-method='setAudio'
          disabled={isUploadPending}
          id='audio'
          name='audio'
          type='file'
          onChange={this.uploadAudio}
        />
        <div className='a-form-input__error'>{uploadError}</div>
      </div>
    );

    return (
      <div className='audio-editor'>
        <div className='audio-editor__fieldset'>
          <TextInput
            className='audio-editor__input'
            data-setter-method='setName'
            error={Boolean(errors.get('name'))}
            errorMessage={errors.get('name', null)}
            label='Name'
            name='name'
            onChange={this.props.onChange}
            placeholder=''
            value={supplement.getName()}
          />
          <TextInput
            className='audio-editor__input'
            data-setter-method='setCaption'
            error={Boolean(errors.get('caption'))}
            errorMessage={errors.get('caption', null)}
            label='Caption'
            name='caption'
            onChange={this.props.onChange}
            placeholder=''
            value={supplement.getCaption()}
          />
        </div>
        {uploadManager}
        <WindowConfirm
          title='Are you sure you want to delete this audio file?'
          message='This action cannot be undone and will impact all questions using this supplement.'
          confirmButtonText='Clear Audio'
          storeName={this.clearAudioModalStoreName}
          onConfirm={this.clearAudio}
        />
      </div>
    );
  }
}
